import React from "react";

const Input = ({ label, name, type = "text", placeholder, value, onChange }) => {
  return (
    <div>
      {label && <label className="form-label">{label}</label>}
      <input
        type={type}
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="form-control"
      />
    </div>
  );
};

export default Input;